import { isEmpty } from 'lodash';
import React, { useMemo, useState } from 'react';

import Collapsible from 'pages/Bulletin/components/Collapsible';
import { formatSource } from 'pages/Bulletin/utils';

import CpeConfiguration from './components/CpeConfiguration';
import Tabs from './components/Tabs';
import useStyles from './styles';
import { CpeConfiguration as CpeConfigurationInterface } from './types';

interface Props {
    detections: Record<`${string}CpeConfiguration`, [CpeConfigurationInterface]>;
    className?: string;
}

const Detections: React.FC<Props> = ({ detections, className }) => {
    const { classes, cx } = useStyles();

    const options = useMemo(
        () =>
            Object.entries(detections ?? {})
                .filter(([key, value]) => key.endsWith('CpeConfiguration') && Array.isArray(value) && !isEmpty(value))
                .map(([key]) => ({
                    value: key,
                    label: formatSource(key.trim().replace('CpeConfiguration', ''))
                })),
        [detections]
    );

    const [head] = options;
    const [value, setValue] = useState(head?.value);

    if (isEmpty(options)) {
        return null;
    }

    return (
        <div className={cx(classes.root, className)}>
            <Tabs options={options} value={value} onChange={setValue} />
            <div className={cx(classes.content, { [classes._rounded]: value !== head?.value })}>
                <Collapsible maxSize={510} key={value} collapseClassName={classes.collapse}>
                    {detections[value].map(({ operator, nodes }, index) => (
                        <CpeConfiguration
                            key={index}
                            operator={operator}
                            data={nodes}
                            className={classes.configuration}
                        />
                    ))}
                </Collapsible>
            </div>
        </div>
    );
};

export default Detections;
